


import { setGetMailingStatisticsScrollerUsersTransactionsAction } from '../action';
import { getMailingStatisticsScrollerUsersDeposits } from '../api/getMailingStatisticsScrollerUsersDeposits';

export const setGetMailingStatisticsScrollerUsersTransactions = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsScrollerUsersDeposits({
                ...params,
                status: 'ready_for_pay'
            });

            dispatch(setGetMailingStatisticsScrollerUsersTransactionsAction(data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}